import React, { ReactElement } from "react";
import { QqTypeEnum } from "../model/qq-type.enum";
import { QqModel } from "../model/qq.model";
import { SliderControlSettingsModel } from "../model/slider-control.settings.model";
import { CheckboxControlSettingsModel } from "../model/checkbox-control.settings.model";
import { DropdownControlSettingsModel } from "../model/dropdown-control.settings.model";
import { StateDispatchProps } from "../components/state-dispatch.props";
import { QqSliderControl } from "./qq-slider-control";
import { QqCheckboxControl } from "./qq-checkbox-control";
import { QqDropdownControl } from "./qq-dropdown-control";

export class QqControlFactory {
  private readonly map: {
    [key: string]: (
      stateDispatch: StateDispatchProps,
      ctrl: QqModel
    ) => ReactElement;
  };

  constructor() {
    this.map = {
      [QqTypeEnum.slider]: (stateDispatch, ctrl) => (
        <QqSliderControl
          key={ctrl.key}
          qq={ctrl}
          dispatch={stateDispatch.dispatch}
          state={stateDispatch.state}
          settings={ctrl.settings as SliderControlSettingsModel}
          options={ctrl.optionsRange ?? []}
        />
      ),
      [QqTypeEnum.checkbox]: (stateDispatch, ctrl) => (
        <QqCheckboxControl
          key={ctrl.key}
          qq={ctrl}
          dispatch={stateDispatch.dispatch}
          state={stateDispatch.state}
          settings={ctrl.settings as CheckboxControlSettingsModel}
          options={ctrl.optionsValue ?? {}}
        />
      ),
      [QqTypeEnum.dropdown]: (stateDispatch, ctrl) => (
        <QqDropdownControl
          key={ctrl.key}
          qq={ctrl}
          dispatch={stateDispatch.dispatch}
          state={stateDispatch.state}
          settings={ctrl.settings as DropdownControlSettingsModel}
          options={ctrl.optionsValue ?? {}}
        />
      ),
    };
  }

  create(stateDispatch: StateDispatchProps, ctrl: QqModel): ReactElement {
    if (!this.map[ctrl.type]) return <div />;

    const func = this.map[ctrl.type];
    return func(stateDispatch, ctrl);
  }
}
